<div [innerHTML]="svg()" [style.--srcIconSize]="size()" class="src-icon"></div>
